const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 980,
    lg: 1280,
    xl: 1536,
  },
}

export default breakpoints
